var _rect, _path, _path2, _path3, _circle, _path4, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrashsentinel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#2b0f15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 390 180 315l85 35 115-145 90 75 125-120 80 80",
    fill: "none",
    stroke: "#fb7185",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 420h600",
    stroke: "#fecdd3",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600 140v215",
    stroke: "#fda4af",
    strokeWidth: 5,
    strokeDasharray: "10 14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 140,
    r: 20,
    fill: "#facc15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M600 205v90M575 250h50",
    stroke: "#fef3c7",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#ffe4e6",
    fontFamily: "sans-serif",
    fontSize: 44,
    fontWeight: 700
  }, "CRASHSENTINEL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#fda4af",
    fontFamily: "monospace",
    fontSize: 22
  }, "MARKET RISK EARLY WARNING")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrashsentinel);
export default __webpack_public_path__ + "static/media/crashsentinel.ba72a59b8f5c4f3f5444d7ac389cf233.svg";
export { ForwardRef as ReactComponent };